import {
  handleDeleteRequest,
  handleGetRequest,
  handlePostRequest,
  handlePutRequest,
} from "./http.service";

export type ServiceProvider = "dojah" | "manual" | "partner_lab";
export type ServiceCategory =
  | "identity"
  | "guarantor"
  | "background"
  | "health"
  | "bundle";

export interface VerificationServiceType {
  _id: string;
  name: string;
  description: string;
  price: number; // stored in kobo
  provider: ServiceProvider;
  turnaround: string;
  isActive: boolean;
  category: ServiceCategory;
  createdAt: string;
}

export interface ServiceTypePayload {
  name: string;
  description: string;
  price: number;
  provider: ServiceProvider;
  turnaround: string;
  isActive?: boolean;
  category: ServiceCategory;
}

export const getAdminCatalog = () =>
  handleGetRequest<VerificationServiceType[]>("/verification-services/admin/catalog");

export const createServiceType = (data: ServiceTypePayload) =>
  handlePostRequest<ServiceTypePayload, VerificationServiceType>(
    "/verification-services/admin",
    data
  );

export const updateServiceType = (id: string, data: Partial<ServiceTypePayload>) =>
  handlePutRequest<Partial<ServiceTypePayload>, VerificationServiceType>(
    `/verification-services/admin/${id}`,
    data
  );

export const deleteServiceType = (id: string) =>
  handleDeleteRequest(`/verification-services/admin/${id}`);
